export default __webpack_public_path__ + "static/media/dgd-icon.18479390.svg";